import React from "react";
import { Mic } from "lucide-react";
import {
  voiceAgentStore,
  voiceAgentActions,
} from "../../../../../store/voiceAgentStore";
import { useSnapshot } from "valtio";

interface StartSessionButtonProps {
  className?: string;
}

const StartSessionButton: React.FC<StartSessionButtonProps> = ({
  className = "",
}) => {
  const { status } = useSnapshot(voiceAgentStore);
  const { startSession } = voiceAgentActions;

  const handleClick = async () => {
    await startSession();
  };

  const isConnecting = status === "connecting";

  return (
    <button
      onClick={handleClick}
      disabled={isConnecting}
      className={`py-3 px-6 rounded-full flex items-center justify-center gap-2 bg-white hover:bg-blue-100 backdrop-blur-sm text-gray-800 font-semibold shadow-lg transition-all duration-300 ${className} ${
        isConnecting ? "opacity-50 cursor-wait" : "cursor-pointer"
      }`}
    >
      <Mic className={`h-5 w-5 ${isConnecting ? "animate-pulse" : ""}`} />
      <span className={`text-sm`}>
        {isConnecting ? "Connecting..." : "Start Session"}
      </span>
    </button>
  );
};

export default StartSessionButton;
